const productsMap: { [key: string]: string } = {
  argus_repo: 'Argus',
  carmenta_deployment: 'Carmenta Deployment',
  web_ui: 'Web UI',
  windows_app: 'Windows App',
  marinas_db: 'Marinas DB',
  gis_engine: 'GIS Engine'
};
export default productsMap;
